export const goToOrigin = () => {
  const { protocol, host } = window.location;
  window.location.replace(`${protocol}//${host}`);
};

export const goToIndex = () => {
  window.history.pushState(history.state, '', `/`);
};
